import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "input-control-multiple" }
const _hoisted_2 = { class: "input-row" }
const _hoisted_3 = ["data-cy"]
const _hoisted_4 = { class: "label" }
const _hoisted_5 = { class: "sub-label" }

import { computed } from "vue";
import { TranslateResult } from "vue-i18n";
import { camelCase } from "lodash";

interface Props {
  options: Array<{
    label: string | TranslateResult;
    subLabel: string | TranslateResult;
    code: string;
    borderColor: string;
  }>;
  value?: Array<string>;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VInputControlMultiple',
  props: {
    options: { default: () => [
    {
      label: "",
      subLabel: "",
      code: "",
      borderColor: "",
    },
  ] },
    value: { default: () => [] }
  },
  emits: ["input"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const activeItem = computed<Array<string>>({
  get() {
    return props.value;
  },
  set(value) {
    emit("input", value);
  },
});

const onClickItem = (value: string) => {
  return () => {
    if (!activeItem.value.includes(value)) {
      activeItem.value.push(value);
    } else {
      activeItem.value = activeItem.value.filter((item: string) => item !== value);
    }
  };
};

const getItemClasses = (item: { code: string }) => {
  return {
    active: activeItem.value.includes(item.code),
    [`${item.borderColor}`]: !!item.borderColor,
  };
};

return (_ctx: any,_cache: any) => {
  const _directive_touch = _resolveDirective("touch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item, index) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass([getItemClasses(item), "item"]),
          "data-cy": `input-control-multiple-${_unref(camelCase)(item.code)}`
        }, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(item.label), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(item.subLabel), 1)
        ], 10, _hoisted_3)), [
          [_directive_touch, onClickItem(item.code)]
        ])
      }), 128))
    ])
  ]))
}
}

})